"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Is there a free trial?",
    a: "Yes — every plan includes a 14-day free trial, no credit card required to start.",
  },
  {
    q: "What happens if I exceed my employee limit?",
    a: "We'll notify you before you hit your plan's limit and help you move to the right tier — no surprise charges or service interruption.",
  },
  {
    q: "Do you offer discounts for nonprofits or startups?",
    a: "Yes, reach out to our sales team via the Contact page and we'll work out a plan that fits.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes, there's no long-term contract on Starter or Growth plans. Enterprise agreements are annual by default but negotiable.",
  },
];

export default function PricingFAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 bg-muted/30 border-t border-border/60">
      <div className="max-w-2xl mx-auto px-6">
        <h2 className="text-2xl font-bold tracking-tight text-foreground text-center mb-10">
          Pricing questions
        </h2>
        <div className="border-t border-border">
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div key={faq.q} className="border-b border-border">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between py-5 text-left"
                >
                  <span className="text-sm font-semibold text-foreground">
                    {faq.q}
                  </span>
                  <ChevronDown
                    size={16}
                    className={`text-muted-foreground transition-transform ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isOpen && (
                  <p className="pb-5 text-sm text-muted-foreground leading-relaxed">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
